module.exports = __webpack_public_path__ + "media/images/lp/1/support2-pc-be60e455fb028bc7cf2eeeb495e62d7e.png";